import { Film, ExternalLink } from 'lucide-react';

const MajesticWhatsOnSection = () => {
  return (
    <div className="content-card" data-testid="majestic-whatson-section">
      <div className="card-header">
        <h2>
          <Film size={20} className="inline" /> Majestic Cinema
        </h2>
      </div>
      <div className="card-content whatson-content">
        <div className="whatson-container">
          <p className="whatson-description">
            King's Lynn's premier cinema showing the latest films and special events.
          </p>
          <a 
            href="https://www.majestic-cinema.co.uk/whatson" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whatson-link-btn"
          >
            <Film size={18} />
            View What's On at Majestic Cinema
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default MajesticWhatsOnSection;
